<template>
  <div>
    <div
      v-if="formCetak.length > 0"
      class="row mt-5"
    >
      <div
        class="col-sm-3"
        v-for="f in formCetak"
        :key="f.id_layanan_dokumen"
      >
        <div
          class="card-item card"
          style="cursor:pointer"
          :title="'Klik untuk melihat form '+f.dokumen.nama_dokumen"
          @click="lihatForm(f)"
        >
          <div class="card-body p-0">
            <div
              class="card-item-bg-img"
              :style="{ backgroundImage: 'url('+$store.getters.getBaseUrl+'/uploads/icon-form/'+f.dokumen.icon+')' }"
            />
            <div
              class="p-3"
              style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis"
            >
              <b>{{ f.dokumen.nama_dokumen }}</b>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      Tidak ada form yang diisi
    </div>
    <b-modal
      id="modal-lihat-form"
      title="Formulir"
      size="lg"
    >
      <div
        class="embed-responsive"
        style="height: 70vh"
      >
        <iframe
          id="iframepdf"
          :src="linkForm"
          class="embed-responsive-item"
        />
      </div>
            
      <template #modal-footer>
        <button
          type="button"
          value=""
          class="btn btn-primary"
          @click="cetakForm"
        >
          <i class="fa fa-print mr-2" />Cetak Formulir
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
    data() {
        return {
            linkForm: ''
        }
    },
    computed: {
        formCetak(){
            let formPermohonan = this.$store.getters.getDataPermohonan.paket_layanan.layanan.layanan_dokumen.filter(e => e.dokumen.kode_dokumen)
            // console.log(formPermohonan)
            let formCetak = []

            let isSetFormPelaporan = false
            this.$store.getters.getDataPermohonan.form.forEach(e => {
                formPermohonan.forEach(f => {
                    if(f.dokumen.kode_dokumen === 'F2.01'){
                        if(e.id === 2011 || e.id === 2012 || e.id === 2013 || e.id === 2014 || e.id === 2015 || e.id === 2016 || e.id === 2017){
                            if(e.form_data){
                                if(!isSetFormPelaporan){
                                    formCetak.push(f)
                                    isSetFormPelaporan = true
                                }
                            }
                        }
                    } else if(f.dokumen.kode_dokumen === 'F2.03'){
                        if(e.form_data && e.id === 203){
                            formCetak.push(f)
                        }
                    } else if(f.dokumen.kode_dokumen === 'F2.04'){
                        if(e.form_data && e.id === 204){
                            formCetak.push(f)
                        }
                    } else if(f.dokumen.kode_dokumen === 'F1.01'){
                        if(e.form_data && e.id === 101){
                            formCetak.push(f)
                        }
                    } else if(f.dokumen.kode_dokumen === 'F1.02'){
                        if(e.form_data && e.id === 102){
                            formCetak.push(f)
                        }
                    } else if(f.dokumen.kode_dokumen === 'F1.03'){
                        if(e.form_data && e.id === 103){
                            formCetak.push(f)
                        }
                    } else if(f.dokumen.kode_dokumen === 'F1.04'){
                        if(e.form_data && e.id === 104){
                            formCetak.push(f)
                        }
                    } else if(f.dokumen.kode_dokumen === 'F1.05'){
                        if(e.form_data && e.id === 105){
                            formCetak.push(f)
                        }
                    } else if(f.dokumen.kode_dokumen === 'F1.06'){
                        if(e.form_data && e.id === 106){
                            formCetak.push(f)
                        }
                    } else if(f.dokumen.kode_dokumen === 'F1.08'){
                        if(e.form_data && e.id === 108){
                            formCetak.push(f)
                        }
                    } else if(f.dokumen.kode_dokumen === 'F1.12'){
                        if(e.form_data && e.id === 112){
                            formCetak.push(f)
                        }
                    } else if(f.dokumen.kode_dokumen === 'F1.15'){
                        if(e.form_data && e.id === 115){
                            formCetak.push(f)
                        }
                    }
                })
            })

            // console.log(formCetak)
            
            return formCetak
        }
    },
    methods: {
        lihatForm(f){
            this.linkForm = ''
            let kodeForm = f.dokumen.kode_dokumen
            let idForm = null
            let dispatchForm = ''

            switch(kodeForm){
                case 'F1.01':
                    idForm = this.$store.getters.getDataPermohonan.form.find(e => e.id === 101).form_data.id_form_biodata
                    dispatchForm = 'cetakFormBiodataPenduduk'
                    break;

                case 'F1.02':
                    idForm = this.$store.getters.getDataPermohonan.form.find(e => e.id === 102).form_data.id_form_pendaftaran
                    dispatchForm = 'cetakFormPendaftaranKepenududukan'
                    break;
                    
                case 'F1.03':
                    idForm = this.$store.getters.getDataPermohonan.form.find(e => e.id === 103).form_data.id_form_pindah_penduduk
                    dispatchForm = 'cetakFormPendaftaranPerpindahanPenduduk'
                    break;
                    
                case 'F1.04':
                    idForm = this.$store.getters.getDataPermohonan.form.find(e => e.id === 104).form_data.id_form_sptmdk
                    dispatchForm = 'cetakFormSptmdk'
                    break;
                    
                case 'F1.05':
                    idForm = this.$store.getters.getDataPermohonan.form.find(e => e.id === 105).form_data.id_form_sptjm_kawin_belum_catat
                    dispatchForm = 'cetakFormSptjmKawinBelumCatat'
                    break;

                case 'F1.06':
                    idForm = this.$store.getters.getDataPermohonan.form.find(e => e.id === 106).form_data.id_form_perubahan_data
                    dispatchForm = 'cetakFormSpPerubahanData'
                    break;
                    
                case 'F1.08':
                    idForm = this.$store.getters.getDataPermohonan.form.find(e => e.id === 108).form_data.id_form_biodata_wni_ln
                    dispatchForm = 'cetakFormBiodataWni'
                    break;

                case 'F1.12':
                    idForm = this.$store.getters.getDataPermohonan.form.find(e => e.id === 112).form_data.id_form_pindah_ln
                    dispatchForm = 'cetakFormSkPindahLuarNegeri'
                    break;

                case 'F1.15':
                    idForm = this.$store.getters.getDataPermohonan.form.find(e => e.id === 115).form_data.id_form_penduduk_non_permanen
                    dispatchForm = 'cetakFormPendudukNonPermanen'
                    break;
                    
                case 'F2.01':
                    idForm = this.$store.getters.getDataPermohonan.form_pelaporan.id_form_pelaporan
                    dispatchForm = 'cetakFormPelaporan'
                    break;
                    
                case 'F2.03':
                    idForm = this.$store.getters.getDataPermohonan.form.find(e => e.id === 203).form_data.id_form_sptjm_kelahiran
                    dispatchForm = 'cetakFormSptjmKelahiran'
                    break;

                case 'F2.04':
                    idForm = this.$store.getters.getDataPermohonan.form.find(e => e.id === 204).form_data.id_form_sptjm_suami_istri
                    dispatchForm = 'cetakFormSptjmSuamiIstri'
                    break;
            }

            this.$store.dispatch(dispatchForm, idForm).then(res => {
                let blob = new Blob([res.data], { type: 'application/pdf' })
                this.linkForm = window.URL.createObjectURL(blob)

            })

            
            this.$bvModal.show('modal-lihat-form')
        },
        cetakForm(){
            window.open(this.linkForm)
        },
    }
}
</script>
